"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubPanels = exports.ErrorTypeOption = exports.SuccessFlags = exports.LinkPosition = exports.EventActions = exports.notifyFriendlyName = exports.PageUrls = exports.CheckoutLinkNames = exports.EventTypesCodes = void 0;
var StateProvider_1 = require("./StateProvider");
var ReportingHelperService_1 = require("./ReportingHelperService");
var Utils = require("../utils/UtilityFunctions");
var ReportingGateway_1 = require("./ReportingGateway");
var cartUtils = require("../utils/CartUtilFunctions");
var CommonUtilFuntions_1 = require("../utils/CommonUtilFuntions");
var ReportingService = /** @class */ (function (_super) {
    __extends(ReportingService, _super);
    function ReportingService() {
        var _this = _super.call(this) || this;
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        return _this;
    }
    ReportingService.prototype.fireLinkClickEvent = function (linkNameValue, linkUrlValue) {
        var subPanelPos = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            subPanelPos[_i - 2] = arguments[_i];
        }
        var linkPosition = this.getLinkPosition(linkNameValue, linkUrlValue, subPanelPos);
        this.firePageLoadEvent(linkUrlValue);
        this.fireLinkClickWithOutPageLoad(linkNameValue, linkUrlValue, linkPosition);
    };
    ReportingService.prototype.fireLinkClickThenPageloadEvent = function (linkNameValue, linkUrlValue) {
        var subPanelPos = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            subPanelPos[_i - 2] = arguments[_i];
        }
        var linkPosition = this.getLinkPosition(linkNameValue, linkUrlValue, subPanelPos);
        this.fireLinkClickWithOutPageLoad(linkNameValue, linkUrlValue, linkPosition);
        this.firePageLoadEvent(linkUrlValue);
    };
    ReportingService.prototype.fireLinkClickWithOutPageLoad = function (linkNameValue, linkUrlValue, linkPosition) {
        var appAnalyticsEvent = {
            additionalData: __assign({ linkDestinationUrl: this.constructFullUrl((linkUrlValue &&
                    linkUrlValue.includes('/buy/checkout') &&
                    !linkUrlValue.includes('/modal')) ? '/buy/checkout/checkoutview' : linkUrlValue), linkName: linkNameValue, linkPosition: linkPosition || this.getLinkPosition(linkNameValue, linkUrlValue, []) }, this.getFlowCodeAndproductType(linkUrlValue)),
            eventAction: EventActions.LINK_CLICK,
            eventCode: EventTypesCodes.LINK_CLICK_EVENT_CODE,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireLinkClickWithOutDestination = function (linkNameValue) {
        var appAnalyticsEvent = {
            additionalData: __assign({ linkName: linkNameValue, linkPosition: LinkPosition.BODY }, this.getFlowCodeAndproductType()),
            eventAction: EventActions.LINK_CLICK,
            eventCode: EventTypesCodes.LINK_CLICK_EVENT_CODE,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.firePageLoadEvent = function (urlVal, forceTrigger, pageTriggerMethod, displayedMessage) {
        if (!this.isSamePage(urlVal) || forceTrigger) {
            var appAnalyticsEvent = {
                additionalData: __assign({ url: urlVal }, this.additionalPageLoadData(pageTriggerMethod, urlVal, displayedMessage)),
                eventAction: EventActions.PAGE_LOAD,
                eventCode: EventTypesCodes.PAGE_LOAD_EVENT_CODE,
            };
            ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
        }
    };
    ReportingService.prototype.fireNumberEligibilityCheckSubmitEvent = function (evtType, isFailure, errorId, errortype, status, successFlag, itemsArray, pAdditionalData) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(PageUrls.DEVICE_OPTIONS_PAGE), 'Check', errortype, status, successFlag)), { items: itemsArray }),
            eventAction: this.getNewEventAction(evtType),
            eventCode: EventTypesCodes.LNP_CHECK_SUBMIT_USER_ACTION,
        };
        pAdditionalData && Object.assign(appAnalyticsEvent.additionalData, pAdditionalData);
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireDeliveryEligibilityCheckSubmitEvent = function (errorInResponse, errorID, linkNameTxt, selPageUrl, selEventType, errorMessage, linkPos, pAdditionalData) {
        // tslint:disable-next-line: no-any
        var appAnalyticsEvent = {
            additionalData: this.getFormatedAdditionalDtlsForDeliveryEvent(errorInResponse, errorID, this.constructFullUrl(selPageUrl), linkNameTxt, errorMessage, linkPos),
            eventAction: this.getNewEventAction(selEventType),
            eventCode: EventTypesCodes.DELIVERY_CHECK_ELIGIBILITY_USER_ACTION,
        };
        Object.assign(appAnalyticsEvent.additionalData, pAdditionalData);
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireOrderSubmitUserActionEvent = function (errorInResponse, errorID, selEventType, errorMsg) {
        var eapContext = cartUtils.getEAPDetails();
        var linkName = 'Submit Order';
        var priceBarData = this.stateManager.get('CHECKOUT', 'priceBarUpdate');
        var prescreenStatus = this.stateManager.get('CHECKOUT', 'creditPreScreenStatus');
        var insuranceData = this.stateManager.get('CART', 'insuranceDetails');
        if (priceBarData && priceBarData.buttonLabel && priceBarData.buttonLabel.toLowerCase().indexOf('apple') > -1) {
            linkName = 'Buy with ApplePay';
        }
        var showNewTyPage = Utils.purchaseorderThankyouRedirection();
        var shippingMethod = this.stateManager.get('CHECKOUT', 'FulFillmethodOpted');
        var appAnalyticsEvent = {
            additionalData: __assign(__assign(__assign(__assign(__assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorID, this.constructFullUrl(showNewTyPage ? PageUrls.PURCHASEORDER_THANKYOU_PAGE :
                PageUrls.THANKYOU_PAGE), linkName, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), { activatedDeviceMake: (eapContext.isEAPFlow ? eapContext.activatedDeviceMake : undefined), activatedDeviceModel: (eapContext.isEAPFlow ? eapContext.activatedDeviceModel : undefined), creditPrescreenFlag: (prescreenStatus ? 1 : 0), crossPayOffPrice: (Utils.getUpgradeAmount('PAYOFF') ? Utils.getUpgradeAmount('PAYOFF') : undefined), crossPayToPrice: (Utils.getUpgradeAmount('PAYUP') ? Utils.getUpgradeAmount('PAYUP') : undefined), donationAmount: (Utils.getDonartionAmount() ? Utils.getDonartionAmount() : undefined), mitigationIds: {
                    category: 'Sales',
                    code: Utils.getMitigationDetails() && Utils.getMitigationDetails().code,
                } }), this.getFormattedInsuranceDetails(insuranceData)), this.reportingGetPoeDetails(errorInResponse)), this.getCartItemDetails(this.getNewEventAction(selEventType))), { cartFulfillMethod: (shippingMethod && shippingMethod.type) ? shippingMethod.type : '' }),
            eventAction: this.getNewEventAction(selEventType),
            eventCode: EventTypesCodes.ORDER_SUBMIT_USER_ACTION,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireNewAccessIDActionEvent = function (errorInResponse, errorID, selEventType, accessID, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorID, this.constructFullUrl(PageUrls.ACCESSID_PAGE), 'Create my Access ID', errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), { userResp: accessID }),
            eventAction: this.getNewEventAction(selEventType),
            eventCode: EventTypesCodes.CREATE_ACCESS_ID_SUBMIT,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireVerifyAccessIDActionEvent = function (errorInResponse, errorID, selEventType, accessID, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorID, this.constructFullUrl(PageUrls.ACCESSID_PAGE), 'Verify my Access ID', errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), { userResp: accessID }),
            eventAction: this.getNewEventAction(selEventType),
            eventCode: EventTypesCodes.VERIFY_ACCESS_ID_SUBMIT,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireCreditVerificationDisplayEvent = function (pageUrl, reportingData) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(false, '0', this.constructFullUrl(pageUrl), '')), reportingData),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: 'DS_System_CheckOut_Credit_Restrictions_Display',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireCreditVerificationSumbitEvent = function (evtType, isFailure, errorId, currentEventCOde, linkName, addlParams, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(PageUrls.CREDIT_VERIFICATION_PAGE), linkName, isFailure ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), addlParams),
            eventAction: this.getNewEventAction(evtType),
            eventCode: currentEventCOde,
        };
        if (addlParams && addlParams.offerTypeFlag) {
            // Set offerTypeFlag=0 as fireCreditVerificationSumbitEvent is not fired for prepaid offer submit
            appAnalyticsEvent.additionalData = __assign(__assign({}, appAnalyticsEvent.additionalData), { offerTypeFlag: '0' });
        }
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireAccountSecuritySubmitEvent = function (evtType, isFailure, errorId, linkName, errorMsg) {
        // tslint:disable-next-line: no-any
        var appAnalyticsEvent = {
            additionalData: this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(PageUrls.ACCOUNT_SECURITY_PANEL), linkName, isFailure ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg),
            eventAction: this.getNewEventAction(evtType),
            eventCode: 'DS_CheckOut_Account_Security_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.firePinRequestSubmitEvent = function (evtType, isFailure, errorId, linkName, errorMsg) {
        // tslint:disable-next-line: no-any
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(PageUrls.PET_MODAL_SEND_PIN), linkName, (isFailure) ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), this.reportingGetPoeDetails(isFailure)),
            eventAction: this.getNewEventAction(evtType),
            eventCode: 'DS_CheckOut_PIN_Request_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.firePinValidationSubmitEvent = function (evtType, isFailure, errorId, linkName, requestId, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormattedPinValidationEventDetails(isFailure, errorId, this.constructFullUrl(PageUrls.PET_MODAL_VALIDATE_PIN), linkName, requestId, errorMsg)), this.reportingGetPoeDetails(isFailure)),
            eventAction: this.getNewEventAction(evtType),
            eventCode: 'DS_CheckOut_PIN_Validation_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireAuthIDMitigationSubmitEvent = function (evtType, isFailure, errorId, linkName, requestId, errorMsg, linkPos) {
        // tslint:disable-next-line: no-any
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(PageUrls.AUTHID_MODAL), linkName, (isFailure) ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg, undefined, linkPos)), this.reportingGetPoeDetails(isFailure)),
            eventAction: this.getNewEventAction(evtType),
            eventCode: EventTypesCodes.AUTHID_MODEL_SUBMIT_EVENT,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireAuthIDMitigationCancelEvent = function (evtType, isFailure, errorId, linkName, requestId, errorMsg, linkPos) {
        // tslint:disable-next-line: no-any
        var appAnalyticsEvent = {
            additionalData: this.getFormatedAdditionalDetails(isFailure, errorId, 'https://www.att.com/', linkName, (isFailure) ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg, undefined, linkPos),
            eventAction: this.getNewEventAction(evtType),
            eventCode: EventTypesCodes.AUTHID_MODEL_CANCEL_EVENT,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireCKAVSumbitEvent = function (evtType, isFailure, errorId, linkName, errorMsg) {
        // tslint:disable-next-line: no-any
        var appAnalyticsEvent = {
            additionalData: this.getFormatedCKAVDetails(isFailure, errorId, linkName, '', errorMsg),
            eventAction: this.getNewEventAction(evtType),
            eventCode: 'DS_Check_Avail_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireCreditSafeScanSumbitEvent = function (evtType, isFailure, errorId, linkName, errorMsg) {
        // tslint:disable-next-line: no-any
        var appAnalyticsEvent = {
            additionalData: this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(PageUrls.CREDIT_SAFE_SCAN_MODAL), linkName, isFailure ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg),
            eventAction: this.getNewEventAction(evtType),
            eventCode: 'DS_CheckOut_SafeScan_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireCreditCheckDebtPaymentDisplayEvent = function (debtTotalAmount, displayedMessage) {
        var appAnalyticsEvent = {
            additionalData: __assign({ debtTotalAmount: debtTotalAmount,
                displayedMessage: displayedMessage }, this.getFormatedAdditionalDetails(false, '0', this.constructFullUrl(PageUrls.CREDIT_DEBT_MODAL), displayedMessage)),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: EventTypesCodes.DEBT_DISPLAY_SYSTEM_EVENT,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireDebtPaymentSubmitEvent = function (evtType, isFailure, errorId, debtTotalAmount, linkName, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(PageUrls.CREDIT_DEBT_MODAL), linkName, isFailure ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), { debtTotalAmount: debtTotalAmount }),
            eventAction: this.getNewEventAction(evtType),
            eventCode: 'DS_CheckOut_Debt_Payment_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireCancelMyOrderEvent = function (evtType, isFailure, errorId, linkName, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign({}, this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(PageUrls.CREDIT_DEBT_MODAL), linkName, isFailure ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)),
            eventAction: this.getNewEventAction(evtType),
            eventCode: 'DS_CheckOut_Cancel_Order_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.firePaymentPanelSubmitEvent = function (reportingData, evt, isFailure, errorId, linkName, errorMsg, successFlag) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, reportingData), this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(PageUrls.PAYMENT_SUB_PAGE), linkName, isFailure ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg, successFlag)),
            eventAction: this.getNewEventAction(evt),
            eventCode: 'DS_CheckOut_Payment_Info_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireBillPreferencesSubmitEvent = function (evtType, errorInResponse, errorId, autoPayPayment, paperlessOpt, isAutoPay, billLang, btxText, errorMsg, citiCardStatus) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.BILLING_PREFERENCE_PANEL), btxText, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), { autoPayFlag: isAutoPay, billLanguage: billLang, cardApplicationStatus: citiCardStatus, paperlessBillFlag: paperlessOpt }), this.getPaymentMethodAutoPay(isAutoPay, autoPayPayment)),
            eventAction: this.getNewEventAction(evtType),
            eventCode: 'DS_CheckOut_Bill_Preferences_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.getPaymentMethodAutoPay = function (isAutoPay, autoPayPayment) {
        if ('1' === isAutoPay) {
            return { paymentMethodAutoPay: autoPayPayment };
        }
    };
    ReportingService.prototype.fireScheduleInstallSystemEvent = function (errorInResponse, errorId, eventTypeParam, dtvFirstInstallDate, dtvFirstInstallTime, dtvTechnicianInstructionsFlag, addInstallContactFlag, dtvCalendarPreferenceFlag, calendarPreferenceFlag, installTime, installDate, differentInstallDateFlag, dtvDifferentInstallDateFlag, singleDispatchFlag, dualCalenderDisplayFlag, eventName, linkName, errorMsg, useOwnerContact) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.SCHEDULE_INSTALATION_PANEL), linkName, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), { calendarPreferenceFlag: calendarPreferenceFlag,
                differentInstallDateFlag: differentInstallDateFlag, dtvAddlInstallContactFlag: addInstallContactFlag, dtvCalendarPreferenceFlag: dtvCalendarPreferenceFlag,
                dtvDifferentInstallDateFlag: dtvDifferentInstallDateFlag,
                dtvFirstInstallDate: dtvFirstInstallDate,
                dtvFirstInstallTime: dtvFirstInstallTime,
                dtvTechnicianInstructionsFlag: dtvTechnicianInstructionsFlag,
                dualCalenderDisplayFlag: dualCalenderDisplayFlag,
                installDate: installDate,
                installTime: installTime,
                singleDispatchFlag: singleDispatchFlag }),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: eventName,
        };
        if (Utils.isSMBNewStandaloneBroadbandFlow()) {
            appAnalyticsEvent.additionalData = __assign(__assign({}, appAnalyticsEvent.additionalData), { contactInfoFlag: useOwnerContact ? '1' : '0' });
        }
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireScheduleInstallDisplayEvent = function (displayedMessage, dtvInstallDate, dtvInstallTime, installTime, installDate, dtvCalendarPreferenceFlag, calendarPreferenceFlag, singleDispatchFlag, dualCalenderDisplayFlag) {
        var additionalData = this.getScheduleInstallData(displayedMessage, dtvCalendarPreferenceFlag, calendarPreferenceFlag, dtvInstallDate, dtvInstallTime, installTime, installDate, dualCalenderDisplayFlag, singleDispatchFlag);
        var appAnalyticsEvent = {
            additionalData: additionalData,
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: 'DS_System_CheckOut_Schedule_Installation_Display',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireScheduleInstallContactDetailsSubmitEvent = function (dtvAddlInstallContactFlag, dtvTechnicianInstructionsFlag, errorInResponse, errorId, eventTypeParam, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.SCHEDULE_INSTALATION_PANEL), 'Add installation-day info', errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), { dtvAddlInstallContactFlag: dtvAddlInstallContactFlag,
                dtvTechnicianInstructionsFlag: dtvTechnicianInstructionsFlag }),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: 'DS_CheckOut_Install_Contact_Instructions_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.firePromoCodeSubmitEvent = function (promoCodeVal, errorInResponse, errorId, eventTypeParam, isApply, linkName, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.PROMO_SUB_PAGE), linkName, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), { promoCode: promoCodeVal }),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: isApply ? 'DS_Cart_Promo_Code_Submit' : 'DS_Cart_Promo_Code_Remove_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireRepCodeSubmitOrRemoveEvent = function (repCodeVal, errorInResponse, errorId, eventTypeParam, isApply, btntext, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.REP_SUB_PAGE), btntext, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)), { repCode: repCodeVal }),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: isApply ? 'DS_Cart_Sales_Rep_Code_Submit' : 'DS_Cart_Sales_Rep_Code_Remove_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireZipCodeValidateEvent = function (errorInResponse, errorId, errorMsg, linkName, eventTypeParam) {
        var appAnalyticsEvent = {
            additionalData: __assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.CART), linkName, errorInResponse ? ErrorTypeOption.Failure_User : ErrorTypeOption.Success_Admit, errorMsg)),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: 'DS_ZipCode_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireCartSummaryDisplay = function () {
        var insuranceData = this.stateManager.get('CART', 'insuranceDetails');
        var URL = cartUtils.getLinkClickBasekUrl();
        var appAnalyticsEvent = {
            additionalData: __assign(__assign(__assign(__assign(__assign(__assign({}, this.getRetrievedCartFlag()), { errorType: ErrorTypeOption.Success_Admit, statusCode: '0', statusMessage: 'success', successFlag: SuccessFlags.SUCCESSFUL }), this.getFlowCodeAndproductType(URL)), this.getFormattedInsuranceDetails(insuranceData)), this.isAccountLock()), this.getCartItemDetails(this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT))),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: 'DS_System_Cart_Summary_Display',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireCreditRestrictionsPrepaidDisplay = function (itemsArray) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(false, '0', this.constructFullUrl(PageUrls.CREDIT_VERIFICATION_RESOULTION_MODAL), undefined)), { items: itemsArray }),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: 'DS_System_CheckOut_Credit_Restrictions_Prepaid_Display',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireRetrieveCartResponseEvent = function (errorInResponse, errorMsg, errorId, eventTypeParam, linkName, emailValue, cartOrderSource, cartOriginatingSystem) {
        var appAnalyticsEvent = {
            additionalData: __assign({ email: emailValue }, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.RETRIEVE_CART_URL), linkName, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: 'DS_Retrieve_Cart_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireCartUpdateSubmitEvent = function (errorInResponse, errorId, eventTypeParam, linkName, errorMsg, linkDUrl, isPostpaidToPrepaid) {
        var appAnalyticsEvent = {
            additionalData: __assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(linkDUrl), linkName, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: EventTypesCodes.CART_UPDATE_IN_CHECKOUT_SUBMIT_EVENT,
        };
        if (isPostpaidToPrepaid) {
            appAnalyticsEvent.additionalData = __assign(__assign({}, appAnalyticsEvent.additionalData), { offerTypeFlag: '1' });
        }
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireSaveCartSubmitEvent = function (errorInResponse, errorMsg, errorId, eventTypeParam, linkName, emailValue) {
        var appAnalyticsEvent = {
            additionalData: __assign({ email: emailValue }, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(PageUrls.SAVE_CART_URL), linkName, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)),
            eventAction: this.getNewEventAction(eventTypeParam),
            eventCode: 'DS_Save_Cart_Submit',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireWirelessEnjoyUserActionEvent = function (evtType, isFailure, errorId, reportingData, evtCode, linkname, errorMsg, linkUrl, linkPos) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(linkUrl || PageUrls.DELIVERY_SUB_PAGE), linkname, isFailure ?
                ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg, undefined, linkPos)), this.getFormatedShippingDetailsInOrder(reportingData)),
            eventAction: this.getNewEventAction(evtType),
            eventCode: evtCode.toString(),
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.reportSystemEventForSelectedAction = function (errorInResponse, errorId, linkNameTxt, eventCodeTxt, selPageUrl, selEventType, errorMsg, itemsArray, linkPos, pAdditionalData) {
        if (eventCodeTxt === EventTypesCodes.NUMBER_SELECTION_SUBMIT_USER_ACTION) {
            var appAnalyticsEvent = {
                additionalData: __assign(__assign({}, this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(selPageUrl), linkNameTxt, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg, null, linkPos)), { items: itemsArray }),
                eventAction: this.getNewEventAction(selEventType),
                eventCode: eventCodeTxt,
            };
            ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
        }
        else {
            // tslint:disable-next-line: no-any
            var appAnalyticsEvent = {
                additionalData: this.getFormatedAdditionalDetails(errorInResponse, errorId, this.constructFullUrl(selPageUrl), linkNameTxt, errorInResponse ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg, undefined, linkPos),
                eventAction: this.getNewEventAction(selEventType),
                eventCode: eventCodeTxt,
            };
            Object.assign(appAnalyticsEvent.additionalData, pAdditionalData);
            ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
        }
    };
    ReportingService.prototype.fireDeliveryInfoSystemEvent = function (eventCodeTxt, dtvnowEquipmentFlag, selfInstallKitFlag) {
        var appAnalyticsEvent = {
            additionalData: __assign({ dtvnowEquipmentFlag: dtvnowEquipmentFlag,
                selfInstallKitFlag: selfInstallKitFlag }, this.getFormatedAdditionalDetails(false, '0', this.constructFullUrl(PageUrls.DELIVERY_SUB_PAGE), undefined)),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: eventCodeTxt,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireWLSDeliveryInfoSystemEvent = function (obj) {
        var appAnalyticsEvent = {
            additionalData: __assign(__assign({}, this.getFormatedShippingDetailsInOrder(obj)), this.getFormatedAdditionalDetails(false, '0', this.constructFullUrl(PageUrls.DELIVERY_SUB_PAGE), undefined)),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: EventTypesCodes.SHIPPING_ADDRESS_SYSTEM_EVENT,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireWSCDisplayEvent = function (pageUrl, displayedMessage) {
        var appAnalyticsEvent = {
            additionalData: __assign({ displayedMessage: displayedMessage }, this.getFormatedAdditionalDetails(false, '0', this.constructFullUrl(pageUrl), undefined)),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: 'DS_System_CheckOut_Cart_Conflict_Display',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireSisfoConfirmSystemEvent = function (cartFulfillMethod) {
        var appAnalyticsEvent = {
            additionalData: __assign({ cartFulfillMethod: cartFulfillMethod }, this.getFormatedAdditionalDetails(false, '0', this.constructFullUrl(PageUrls.CART), undefined)),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: 'DS_System_Cart_Summary_Display',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireInstallmentBillingSystemEvent = function () {
        var appAnalyticsEvent = {
            additionalData: __assign({ nrcBillInstallViewFlag: '1' }, this.getFormatedAdditionalDetails(false, '0', this.constructFullUrl(PageUrls.INSTALLMENT_BILLING), undefined)),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: 'DS_System_CheckOut_Installment_Billing_Display',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    /* istanbul ignore next */ // Ignoring this function as it is not used in the current code base
    ReportingService.prototype.fireCheckoutCTODisplay = function () {
        if (!this.isSamePage(PageUrls.CTO_CHECKOUT_PAGE)) {
            // tslint:disable-next-line:no-any
            var hardData = this.stateManager.get('CHECKOUT', 'hardStop');
            var statusCode = CommonUtilFuntions_1.getReasonCode(hardData) || '-2';
            var statusMessage = (hardData === null || hardData === void 0 ? void 0 : hardData.hardStopperText) || 'UNKNOWN';
            this.firePageLoadEvent(PageUrls.CTO_CHECKOUT_PAGE, true);
            var appAnalyticsEvent = {
                additionalData: __assign({}, this.getFormatedAdditionalDetailsCto(statusCode, statusMessage, this.constructFullUrl(PageUrls.CTO_CHECKOUT_PAGE), undefined)),
                eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
                eventCode: 'DS_System_CheckOut_CTO_Display',
            };
            ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
        }
    };
    ReportingService.prototype.fireCheckoutCartErrorDisplay = function (data) {
        if (!this.isSamePage(PageUrls.CTO_CHECKOUT_PAGE)) {
            var appAnalyticsEvent = {
                additionalData: __assign({}, this.getFormatedAdditionalDetails(true, (data === null || data === void 0 ? void 0 : data.statusCode) || '-2', this.constructFullUrl(PageUrls.CTO_CART_ERROR_MODAL), undefined, undefined, data === null || data === void 0 ? void 0 : data.statusMessage)),
                eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
                eventCode: 'DS_System_Cart_Error_Display',
            };
            ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
        }
    };
    ReportingService.prototype.firePaymentInfoDisplaySystemEvent = function (reportingData) {
        if (!this.isSamePage(PageUrls.PAYMENT_SUB_PAGE)) {
            this.firePageLoadEvent(PageUrls.PAYMENT_SUB_PAGE, true);
            var appAnalyticsEvent = {
                additionalData: __assign({ cardApplicationStatus: reportingData === null || reportingData === void 0 ? void 0 : reportingData.cardApplicationStatus, cardOnFileFlag: reportingData && reportingData.cardOnFileFlag, dueTodayTotalAmt: reportingData && reportingData.dueTodayTotalAmt ? reportingData.dueTodayTotalAmt : undefined, eligibleToReapplyFlag: reportingData === null || reportingData === void 0 ? void 0 : reportingData.eligibleToReapplyFlag, paymentDetails: reportingData && reportingData.paymentDetails, statusCode: 0, successFlag: 1 }, this.getFormatedAdditionalDetails(false, '0', this.constructFullUrl(PageUrls.PAYMENT_SUB_PAGE), undefined)),
                eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
                eventCode: 'DS_System_CheckOut_Payment_Info_Display',
            };
            ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
        }
    };
    ReportingService.prototype.publishAnalytics = function (analyticData, responseStatusFlag) {
        // Check if we have success response from API call.
        if (responseStatusFlag !== undefined) {
            analyticData.additionalData = Object.assign(analyticData.additionalData, {
                errorType: responseStatusFlag ? ErrorTypeOption.Success_Admit : ErrorTypeOption.Failure_System,
                statusCode: responseStatusFlag ? '0' : '-1',
                statusMessage: responseStatusFlag ? 'Success' : 'Failure',
                successFlag: responseStatusFlag ? SuccessFlags.SUCCESSFUL : SuccessFlags.UNSUCCESSFUL,
            });
        }
        ReportingGateway_1.default.sendReportingEvent(analyticData);
    };
    ReportingService.prototype.fireACPFlowGAASapiErrorEvent = function (isFailure, errorId, errorMsg) {
        var appAnalyticsEvent = {
            additionalData: __assign({}, this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(PageUrls.ACCOUNT_INFO_SUB_PAGE), '', isFailure ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg)),
            eventAction: this.getNewEventAction(EventTypesCodes.SYSTEM_EVENT),
            eventCode: 'DS_System_CheckOut_ACP_Error_Response',
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.fireBillEstimatorEvent = function (evtType, isFailure, errorId, linkName, errorMsg, linkPos) {
        // tslint:disable-next-line: no-any
        var appAnalyticsEvent = {
            additionalData: this.getFormatedAdditionalDetails(isFailure, errorId, this.constructFullUrl(PageUrls.BILL_ESTIMATOR_PANEL), linkName, (isFailure) ? ErrorTypeOption.Failure_System : ErrorTypeOption.Success_Admit, errorMsg, undefined, linkPos),
            eventAction: this.getNewEventAction(evtType),
            eventCode: EventTypesCodes.ESTIMATE_FUTURE_BILL_USER_ACTION,
        };
        ReportingGateway_1.default.sendReportingEvent(appAnalyticsEvent);
    };
    ReportingService.prototype.isSamePage = function (url) {
        var pageInfo = this.stateManager.get('CHECKOUT', 'CurrentPageURL');
        if (pageInfo && pageInfo.name && pageInfo.name === url) {
            return true;
        }
        else {
            this.stateManager.set('CurrentPageURL', { name: url });
            return false;
        }
    };
    ReportingService.prototype.getNewEventAction = function (evtType) {
        var evntAction;
        if (evtType === EventTypesCodes.FORM_SUBMIT_EVENT) {
            evntAction = EventActions.FORM_SUBMIT;
        }
        else if (evtType === EventTypesCodes.FORM_RESPONSE_EVENT) {
            evntAction = EventActions.FORM_RESPONSE;
        }
        else if (evtType === EventTypesCodes.SYSTEM_EVENT) {
            evntAction = EventActions.SYSTEM_EVENT;
        }
        return evntAction;
    };
    return ReportingService;
}(ReportingHelperService_1.default));
exports.default = ReportingService;
var EventTypesCodes;
(function (EventTypesCodes) {
    EventTypesCodes["LINK_CLICK_EVENT"] = "linkClick";
    EventTypesCodes["LINK_CLICK_EVENT_CODE"] = "Link_Click";
    EventTypesCodes["PAGE_LOAD_EVENT"] = "pageLoad";
    EventTypesCodes["PAGE_LOAD_EVENT_CODE"] = "Page_Load";
    EventTypesCodes["FORM_SUBMIT_EVENT"] = "formSubmit";
    EventTypesCodes["FORM_RESPONSE_EVENT"] = "formResponse";
    EventTypesCodes["SYSTEM_EVENT"] = "systemEvent";
    EventTypesCodes["CREDIT_VERIFICATION_SYSTEM_EVENT"] = "DS_CheckOut_Credit_Verification_Submit";
    EventTypesCodes["CREDIT_RESTRICTIONS_USER_EVENT"] = "DS_CheckOut_Credit_Restrictions_Submit";
    EventTypesCodes["CREDIT_CHECK_REMOVE_LINE_SYSTEM_EVENT"] = "DS_Line_Remove_Submit";
    EventTypesCodes["ADDRESS_DETAILS_SYSTEM_EVENT"] = "DS_CheckOut_Address_Details_Submit";
    EventTypesCodes["CONTACT_DETAILS_SYSTEM_EVENT"] = "DS_CheckOut_Personal_Info_Submit";
    EventTypesCodes["DELIVERY_ADDRESS_SYSTEM_EVENT"] = "DS_CheckOut_Delivery_Address_Submit";
    EventTypesCodes["SHIPPING_ADDRESS_SYSTEM_EVENT"] = "DS_System_CheckOut_DeliveryInfo_Display";
    EventTypesCodes["DELIVERY_CHECK_ELIGIBILITY_USER_ACTION"] = "DS_CheckOut_Delivery_Check_Eligibility_Submit";
    EventTypesCodes["DELIVERY_ADDRESS_UPDATE_USER_ACTION"] = "DS_CheckOut_Delivery_Update_Address_Submit";
    EventTypesCodes["DELIVERY_UPDATE_DATE_TIME_USER_ACTION"] = "DS_CheckOut_Delivery_Update_Date_Time_Submit";
    EventTypesCodes["SAVE_SHIPPING_SUBMIT_USER_ACTION"] = "DS_CheckOut_Delivery_Options_Submit";
    EventTypesCodes["ORDER_SUBMIT_USER_ACTION"] = "DS_CheckOut_Order_Submit";
    EventTypesCodes["LNP_CHECK_SUBMIT_USER_ACTION"] = "DS_Wireless_LNP_Check_Submit";
    EventTypesCodes["SCHEDULE_INSTALL_SUBMIT_ACTION"] = "DS_CheckOut_ScheduleInstall_Submit";
    EventTypesCodes["SCHEDULE_INSTALL_CONTACT_UPDATE_ACTION"] = "DS_CheckOut_Install_Contact_Instructions_Submit";
    EventTypesCodes["CREATE_ACCESS_ID_SUBMIT"] = "DS_CheckOut_Create_AccessID_Submit";
    EventTypesCodes["VERIFY_ACCESS_ID_SUBMIT"] = "DS_CheckOut_Verify_AccessID_Submit";
    EventTypesCodes["DEBT_DISPLAY_SYSTEM_EVENT"] = "DS_System_UnpaidDebt_Display";
    EventTypesCodes["EMPTY_CART_SUBMIT_EVENT"] = "DS_Empty_Cart_Submit";
    EventTypesCodes["REMOVE_CART_SUBMIT_EVENT"] = "DS_Remove_Cart_Submit";
    EventTypesCodes["FUTURE_BILL_SUBMIT_EVENT"] = "DS_Cart_Future_Bill_Submit";
    EventTypesCodes["CART_UPDATE_IN_CHECKOUT_SUBMIT_EVENT"] = "DS_Cart_Update_Submit";
    EventTypesCodes["NUMBER_SELECTION_SUBMIT_USER_ACTION"] = "DS_CheckOut_LNP_Carrier_Info_Submit";
    EventTypesCodes["NUMBER_SELECTION_SYSTEM_USER_ACTION"] = "DS_System_CheckOut_LNP_Display";
    EventTypesCodes["AUTHID_MODEL_SUBMIT_EVENT"] = "DS_CheckOut_AuthID_Mitigation_Submit";
    EventTypesCodes["AUTHID_MODEL_CANCEL_EVENT"] = "DS_CheckOut_Cancel_Order_Submit";
    EventTypesCodes["ESTIMATE_FUTURE_BILL_USER_ACTION"] = "DS_CheckOut_Estimate_Future_Bill_Submit";
    EventTypesCodes["DS_StoreAvail_Check"] = "DS_StoreAvail_Check_Submit";
    EventTypesCodes["DS_Zipcode_Submit"] = "DS_Zipcode_Submit";
})(EventTypesCodes = exports.EventTypesCodes || (exports.EventTypesCodes = {}));
var CheckoutLinkNames;
(function (CheckoutLinkNames) {
    CheckoutLinkNames["PAYMENT_NORTON_LINK"] = "Payment norton security";
    CheckoutLinkNames["USER_CANCEL_ACTION"] = "Cancel";
    CheckoutLinkNames["MODAL_CLOSE"] = "Close";
    CheckoutLinkNames["ACCOUNT_INFO_NORTON_LINK"] = "Account info norton security";
    CheckoutLinkNames["CREDIT_REVIEW_NORTON_LINK"] = "Credit review norton security";
})(CheckoutLinkNames = exports.CheckoutLinkNames || (exports.CheckoutLinkNames = {}));
var PageUrls;
(function (PageUrls) {
    PageUrls["CART_PAGE"] = "/buy/cart";
    PageUrls["CARTVIEW_PAGE"] = "/buy/checkout/cartview";
    PageUrls["CHECKOUT_PAGE"] = "/buy/checkout/checkoutview";
    PageUrls["THANKYOU_PAGE"] = "/buy/thankyou";
    PageUrls["PURCHASEORDER_THANKYOU_PAGE"] = "/buy/purchaseorder/thankyou";
    PageUrls["PAYMENT_SUB_PAGE"] = "/buy/checkout/payment";
    PageUrls["VOICE_SUB_PAGE"] = "/buy/checkout/voiceinfo";
    PageUrls["TERMS_SUB_PAGE"] = "/buy/checkout/terms";
    PageUrls["SUBSCRIBER_INFO_MODAL"] = "/buy/checkout/dtvnsubscriberdetails";
    PageUrls["TERMS_MODAL_PAGE"] = "/buy/checkout/terms/modal";
    PageUrls["APP_PRIVACY_MODAL"] = "/buy/checkout/dtvnappprivacy";
    PageUrls["DELIVERY_SUB_PAGE"] = "/buy/checkout/deliveryinfo";
    PageUrls["STORE_LIST"] = "/cart/virtual/checkInStoreAvailability";
    PageUrls["ACCOUNT_INFO_SUB_PAGE"] = "/buy/checkout/billinginfo";
    PageUrls["MULTIMATCH_MODAL_PAGE"] = "/buy/multiaddress/modal";
    PageUrls["CHECKOUT_ERROR_SUB_PAGE"] = "/buy/checkout/errorcto";
    PageUrls["IDSE_BUY_PAGE"] = "/buy";
    PageUrls["ACCESSID_PAGE"] = "/buy/checkout/accessid";
    PageUrls["ACCESSID_EXISTINGACCESSID_PAGE"] = "ExistingAccessID";
    PageUrls["ACCESSID_FORGOT_PASSWORD"] = "https://m.att.com/my/#/forgotLoginLanding?origination_point=IDSE&Flow_Indicator=FPWD&olamRedirectInd=DSS";
    PageUrls["ACCESSID_FORGOT_ID"] = "https://m.att.com/my/#/forgotLoginLanding?origination_point=IDSE&Flow_Indicator=FID&olamRedirectInd=DSS";
    PageUrls["ACCESSID_TERMS_SUB_PAGE"] = "/dtvnow/accessid/terms/modal";
    PageUrls["PROMO_SUB_PAGE"] = "/buy/cart/promo";
    PageUrls["REP_SUB_PAGE"] = "/buy/cart/rep";
    PageUrls["PROMO_MODAL_PAGE"] = "/dtvnow/promo/modal";
    PageUrls["CREDIT_VERIFICATION_PAGE"] = "/buy/checkout/creditverification";
    PageUrls["INSTALLMENT_BILLING"] = "/buy/checkout/installmentbilling";
    PageUrls["DEVICE_TRADE_IN"] = "/buy/checkout/tradein";
    PageUrls["DEVICE_TRADE_IN_TnC"] = "/buy/checkout/tradeIn/tnc";
    PageUrls["CREDIT_BANLIMITS_MODAL"] = "/buy/checkout/banlimits/modal";
    PageUrls["CREDIT_VERIFICATION_REMOVELINE_MODAL"] = "/buy/checkout/removeline/modal";
    PageUrls["CREDIT_VERIFICATION_RESOULTION_MODAL"] = "/buy/checkout/creditresolution/modal";
    PageUrls["CREDIT_SAFE_SCAN_MODAL"] = "/buy/checkout/safescan/modal";
    PageUrls["CREDIT_VERIFICATION_ADDL_INFO"] = "/buy/checkout/addlInfo/modal";
    PageUrls["CREDIT_DEBT_MODAL"] = "/buy/checkout/creditdebt/modal";
    PageUrls["WSC_CONFLICT_MODAL"] = "/buy/checkout/wscconflict/modal";
    PageUrls["SCHEDULE_INSTALATION_PANEL"] = "/buy/checkout/scheduleInstall";
    PageUrls["INSTALATION_APPOINTMENT_MODAL"] = "/buy/checkout/appointment/modal";
    PageUrls["INSTALATION_DAY_CONTACT_MODAL"] = "/buy/checkout/daycontact/modal";
    PageUrls["LNP_PPU_MODAL"] = "/buy/checkout/lnpppu/modal";
    PageUrls["LNP_ACCOUNT_HOLDER_MODAL"] = "/buy/checkout/lnpaccountholder/modal";
    PageUrls["LNP_AREA_CODE_MODAL"] = "/buy/checkout/lnpareacode/modal";
    PageUrls["DEVICE_OPTIONS_PAGE"] = "/buy/checkout/numberselection";
    PageUrls["BILLING_PREFERENCE_PANEL"] = "/buy/checkout/billpreferences";
    PageUrls["DONATION_OPTIONS_PANEL"] = "/buy/checkout/donation";
    PageUrls["ACCOUNT_SECURITY_PANEL"] = "/buy/checkout/accountsecurity";
    PageUrls["SEE_OFFER_MODAL_PAGE"] = "/buy/dtvnow/promo/modal";
    PageUrls["SEE_YOUR_FUTURE_BILL_URL"] = "/buy/cart/futureBills/modal";
    PageUrls["IN_COMPLETE_CART_MODAL_URL"] = "/buy/cart/incompletecart/modal";
    PageUrls["CARTMODALREMOVE"] = "/dtvnow/cart/modal/";
    PageUrls["CART_SEE_DETAILS_DUE_TODAY_MODAL"] = "/buy/cart/seedetailsduetoday/modal";
    PageUrls["CART_EXPRESS_SEE_DETAILS_MODAL"] = "/buy/cart/seedetailsexp/modal";
    PageUrls["CART_SEE_DETAILS_DUE_MONTHLY_MODAL"] = "/buy/cart/seedetailsduemonthly/modal";
    PageUrls["CART_SEE_DETAILS_DUE_1STBILL_MODAL"] = "/buy/cart/seedetailsduefirstbill/modal";
    PageUrls["CART_SEE_DETAILS_TAXES_FEES_MODAL"] = "/buy/cart/taxes-fees/modal";
    PageUrls["CART_SEE_DETAILS_SEASONAL_SUBSCRIPTION"] = "/buy/cart/seedetailseasonal/modal";
    PageUrls["CART_BOGO_SEE_OFFER_DETAILS_MODAL"] = "/buy/cart/bogoseeofferdetails/modal";
    PageUrls["CART_TRADEIN_NEW_MODAL"] = "/buy/cart/tradeinoffer/modal";
    PageUrls["CART_ACCESS_FEE_HELP"] = "/buy/cart/accessfeehelp/modal";
    PageUrls["REMOVE_ALL_ITEMS_MODAL"] = "/buy/cart/removeallitems/modal";
    PageUrls["DELIVERY_TIME_SELECTION"] = "/buy/checkout/deliveryinfo/timeselection/modal";
    PageUrls["C2S_STORE_LIST_PAGE"] = "/buy/checkout/storelist/modal";
    PageUrls["DELIVERY_CHECK_AVAILABILITY"] = "/buy/checkout/deliveryinfo/checkavailability/modal";
    PageUrls["DELIVERY_SEE_DETAILS"] = "/buy/checkout/deliveryinfo/expresseedetails/modal";
    PageUrls["DELIVERY_INFO_VERIFYADDRESS_MODAL"] = "/buy/checkout/deliveryinfo/verifyaddress/modal";
    PageUrls["DELIVERY_INFO_ENJOY_MODAL"] = "/buy/checkout/deliveryinfo/enjoyaddress/modal";
    PageUrls["CARTMODALCLOSE"] = "/dtvnow/cart/modal/";
    PageUrls["CARTMODALCANCEL"] = "/dtvnow/cart/modal/";
    PageUrls["CARTEMPTY"] = "/buy/cart/emptycart";
    PageUrls["CART"] = "/buy/cart";
    PageUrls["CARTMODAL"] = "/dtvnow/cart/modal";
    PageUrls["BB_LEARN_MORE_MODAL"] = "/buy/broadband/ip-usage-learn-more/modal";
    PageUrls["DTVNOWERRORMODAL"] = "/dtvnow/error/modal";
    PageUrls["DTVNOWERRORMODALCLOSE"] = "/dtvnow/error/modal/";
    PageUrls["RETRIEVE_CART_URL"] = "/buy/cart/retrieve/modal";
    PageUrls["SIGN_IN"] = "https://www.att.com/shop/login/login.html?retrievecart=true";
    PageUrls["SAVE_CART_URL"] = "/buy/cart/save/modal";
    PageUrls["PRIVACY_POLICY"] = "https://att.com/privacy";
    PageUrls["CKAV_RED_RESPONSE_MODAL"] = "/buy/checkout/redresponse/modal";
    PageUrls["CKAV_EXITING_RESPONSE_MODAL"] = "/buy/checkout/planchange/modal";
    PageUrls["CKAV_CLOSE_MATCH_MODAL"] = "/buy/checkout/closematch/modal";
    PageUrls["CKAV_MDU_MATCH_MODAL"] = "/buy/checkout/mdumatch/modal";
    PageUrls["CKAV_ORDER_CHANGE_MODAL"] = "/buy/checkout/planchange/modal";
    PageUrls["CKAV_RED_MODAL"] = "/buy/checkout/redresponse/modal";
    PageUrls["CKAV_CTO_MODAL"] = "buy/checkout/ckavcto/modal";
    PageUrls["THANK_YOU_MODAL"] = "/buy/cart/thankyou/modal";
    PageUrls["PET_MODAL_SEND_PIN"] = "/buy/checkout/pet/sendpin/modal";
    PageUrls["PET_MODAL_VALIDATE_PIN"] = "/buy/checkout/pet/validatepin/modal";
    PageUrls["PROTECTION_MODAL_PAGE_URL"] = "/buy/thankyou/protection/modal";
    PageUrls["CLOSER_COUPON_MODAL"] = "/buy/orderabandon/modal";
    PageUrls["SEE_PAYMENT_SCHEDULE_MODAL_CART"] = "/buy/cart/paymentschedule/modal";
    PageUrls["CTO_CART_ERROR_MODAL"] = "/buy/checkout/carterror/modal";
    PageUrls["CTO_ERROR_MODAL"] = "/buy/checkout/errorcto/modal";
    PageUrls["CTO_CHECKOUT_PAGE"] = "/buy/checkout/errorcto";
    PageUrls["WIRELESS_PLAN_MODAL"] = "/buy/cart/pricebreakdown/modal";
    PageUrls["MONTHLY_SAVINGS_MODAL"] = "/buy/cart/newprice/modal";
    PageUrls["SHARE_CART_MODAL"] = "/buy/cart/sharecart/modal";
    PageUrls["CART_EDIT_POPUP_URL"] = "/buy/cart/changeproductdetail/modal";
    PageUrls["CART_EDIT_COLOR_CAPACITY_URL"] = "/buy/cart/changecolorcapacity/modal";
    PageUrls["CHKOUT_CART_PANEL_DISPLAY"] = "/buy/checkout/cartview";
    PageUrls["DELIVERY_INFO_ENJOY_CONTACT_MODAL"] = "buy/checkout/deliveryinfo/contactinfo/modal";
    PageUrls["DELIVERY_INFO_IHX_MODAL"] = "/buy/checkout/deliveryinfo/ihxaddress/modal";
    PageUrls["CTO_CHECKOUT_OOS_MODAL"] = "/buy/checkout/outofstock/modal";
    PageUrls["CTO_CHECKOUT_INSUFFICIENT_INVENTORY_MODAL"] = "/buy/checkout/insufficientinventory/modal";
    PageUrls["CTO_CHECKOUT_NO_COMMON_SHIPPING_MODAL"] = "/buy/checkout/nocommonshipping/modal";
    PageUrls["RECONNECT_MODEL"] = "/buy/checkout/tvreconnectcustomer/modal";
    PageUrls["DELIVERY_HYLA_RETURN"] = "/buy/checkout/deliveryinfo/tradeInReturn";
    PageUrls["DELIVERY_HYLA_RETURN_SELECTED"] = "/buy/checkout/deliveryinfo/hylareturnoption";
    PageUrls["AUTHID_MODAL"] = "/buy/checkout/idauthentication/modal";
    PageUrls["ACP_ERROR_MODAL"] = "/buy/checkout/acpincorrectpersonalinfo/modal";
    PageUrls["BILL_ESTIMATOR_PANEL"] = "/buy/checkout/estimatefuturebillinfo";
    PageUrls["SERVICE_VIOLATION_MODAL"] = "/buy/checkout/serviceviolation/modal";
})(PageUrls = exports.PageUrls || (exports.PageUrls = {}));
exports.notifyFriendlyName = {
    '/buy/checkout/personal': 'DS Checkout Personal Info Pg',
    '/buy/checkout/payment': 'DS Checkout Payment Info Pg',
    '/buy/checkout/terms/modal': 'DS Checkout Terms And Conditions Modal Pg',
    '/buy/checkout/billpreferences': 'DS Checkout Bill Preferences Pg',
    '/buy/checkout/deliveryinfo': 'DS Checkout Delivery Info Pg',
    '/buy/checkout/errorcto': 'DS Checkout CTO Pg',
    '/buy/checkout/addressdetails': 'DS Checkout Address Info Pg',
    '/buy/checkout/terms': 'DS Checkout Terms And Conditions Pg',
    '/buy/checkout/scheduleInstall': 'DS Checkout Schedule Installation Pg',
    '/buy/checkout/appointment/modal': 'DS Checkout Schedule Preference Modal Pg',
    '/buy/checkout/daycontact/modal': 'DS Checkout Installation Contact Info Modal Pg',
    '/buy/checkout/creditverification': 'DS Checkout Credit Info Pg',
    '/buy/checkout/addlInfo/modal': 'DS Checkout Additional Info Modal Pg',
    '/buy/checkout/numberselection': 'DS Checkout Device Options Pg',
    '/buy/checkout/removeline/modal': 'DS Checkout Credit Verfication Remove Line Modal Pg',
    '/buy/checkout/lnpppu/modal': 'DS Checkout Device Options LNP PPU Modal Pg',
    '/buy/checkout/lnpareacode/modal': 'DS Checkout Device Options LNP Area Code Modal Pg',
    '/buy/checkout/creditdebt/modal': 'DS CheckOut Debt Payment Modal Pg',
    '/buy/checkout/deliveryinfo/timeselection/modal': 'DS Checkout Delivery Time Selection Modal Pg',
    '/buy/checkout/deliveryinfo/checkavailability/modal': 'DS Checkout Delivery Check Availability Modal Pg',
    '/buy/checkout/wscconflict/modal': 'DS Cart Wireline Service Conflict Modal Pg',
    '/buy/checkout/lnpaccountholder/modal': 'DS Checkout Device Options LNP Account Holder Modal Pg',
    '/buy/checkout/accountsecurity': 'DS Checkout Account Security Pg',
    '/buy/checkout/safescan/modal': 'DS CheckOut SafeScan Information Modal Pg',
    '/buy/checkout/installmentbilling': 'DS CheckOut Internet Installment Billing Pg',
    '/buy/checkout/billinginfo': 'DS Checkout Personal and Billing Info Pg',
    '/buy/checkout/redresponse/modal': 'DS Checkout Red Response Modal Pg',
    '/buy/checkout/planchange/modal': 'DS Checkout Plan Change Modal Pg',
    '/buy/checkout/nomatch/modal': 'DS Checkout No Match Modal Pg',
    '/buy/checkout/D2Lite/modal': 'DS Checkout D2Lite Modal Pg',
    '/buy/checkout/mdumatch/modal': 'DS Checkout MDU Match Modal Pg',
    '/buy/checkout/closematch/modal': 'DS Checkout Close Match Modal Pg',
    '/buy/checkout/creditverification/creditresolution/modal': 'DS CheckoutCredit Resolution Modal Pg',
    '/buy/checkout/creditresolution/modal': 'DS Checkout Credit Resolution Modal Pg',
    '/buy/checkout/accessid': 'DS Checkout Account Access Pg',
    '/buy/checkout/personalinfo': 'DS CheckOut Personal Information Pg',
    '/buy/checkout/addressinfo': 'DS Checkout Address Info Pg',
    '/buy/checkout': 'DS Checkout Account Access Option Pg',
    '/buy/checkout/dtvnsubscriberdetails': 'DS DTVN Subscriber Details Pg',
    '/buy/checkout/dtvnterms': 'DS Checkout DTVN Terms Pg',
    '/buy/checkout/dtvnappprivacy': 'DS Checkout DTVN App Privacy Pg',
    '/buy/checkout/multiaddressmodal': 'DS Checkout Multi Address Modal Pg',
    '/buy/checkout/dtvnsubscriberdetails/modal': 'DS DTVN Subscriber Details Pg',
    '/buy/checkout/dtvnterms/modal': 'DS Checkout DTVN Terms Pg',
    '/buy/checkout/dtvnappprivacy/modal': 'DS Checkout DTVN App Privacy Pg',
    '/buy/checkout/deviceoptions': 'DS Checkout Device Options Pg',
    '/buy/checkout/deviceoptions/lnpppu/modal': 'DS Checkout Device Options LNP PPU Modal Pg',
    '/buy/checkout/deviceoptions/lnpaccountholder/modal': 'DS Checkout Device Options LNP Account Holder Modal Pg',
    '/buy/checkout/deviceoptions/lnpareacode/modal': 'DS Checkout Device Options LNP Area Code Modal Pg',
    '/buy/checkout/creditverification/banlimits/modal': 'DS Checkout Credit Verification BAN Limits Modal Pg',
    '/buy/checkout/creditverification/removeline/modal': 'DS Checkout Credit Verfication Remove Line Modal Pg',
    '/buy/checkout/crpterms': 'DS Checkout Terms And Conditions Pg',
    '/buy/checkout/creditverification/addlInfo': 'DS Checkout Additional Info Pg',
    '/buy/checkout/banlimits/modal': 'DS Checkout Credit Verification BAN Limits Modal Pg',
    '/buy/checkout/wirelessinsurance/modal': 'DS Checkout Wireless Insurance Modal Pg',
    '/buy/checkout/wirelesscustomeragreement/modal': 'DS Checkout Wireless Customer Agreement Modal Pg',
    '/buy/checkout/wirelesselectronicconsent/modal': 'DS Checkout Wireless Electronic Consent Modal Pg',
    '/buy/checkout/wirelessretailinsallment/modal': 'DS Checkout Wireless Retail Installment Modal Pg',
    '/buy/checkout/paymentinfo': 'DS CheckOut Payment Information Pg',
    '/buy/checkout/checkoutview': 'DS Checkout Pg',
    '/buy/checkout/tradein': 'DS Checkout Trade In Pg',
    '/buy/checkout/pet/validatepin/modal': 'DS Checkout Validate PIN Modal Pg',
    '/buy/checkout/pet/sendpin/modal': 'DS Checkout Send PIN Modal Pg',
    '/buy/checkout/rsn/modal': 'DS Checkout RSN Fee Modal Pg',
    '/buy/checkout/carterror/modal': 'DS Checkout Cart Error Modal Pg',
    '/buy/checkout/errorcto/modal': 'DS Checkout CTO Modal Pg',
    '/buy/checkout/cartview': 'DS Checkout Cart Summary Pg',
    '/buy/checkout/deliveryinfo/verifyaddress/modal': 'DS Checkout Delivery Verify Address Modal Pg',
    '/buy/checkout/outofstock/modal': 'DS Checkout Out Of Stock Pg',
    '/buy/checkout/insufficientinventory/modal': 'DS Checkout Insufficient Inventory Pg',
    '/buy/checkout/tvreconnectcustomer/modal': 'DS Checkout Tv Reconnect Customer Pg',
    '/buy/checkout/voiceinfo': 'DS Checkout SMB VOIP Options Pg',
    '/buy/checkout/insurancezipmandate/modal': 'DS CheckOut Zipcode Mandate Modal Pg',
    '/buy/checkout/insurancezipmultiline/modal': 'DS CheckOut Zipcode Multiline Modal Pg',
    '/buy/checkout/insurancezipnonmandate/modal': 'DS CheckOut Zipcode Non Mandate Modal Pg',
    '/buy/checkout/accountlocked/modal': 'DS Checkout Account Locked Modal Pg',
    '/buy/checkout/idauthentication/modal': 'DS Checkout ID Authentication Modal Pg',
    '/buy/checkout/acpincorrectpersonalinfo/modal': 'DS Checkout ACP Incorrect Personal Info Modal Pg',
    '/buy/checkout/estimatefuturebillinfo': 'DS Checkout Estimate Future Bill Info Pg',
    '/buy/checkout/serviceviolation/modal': 'DS Checkout Service Violation Modal Pg',
};
var EventActions;
(function (EventActions) {
    EventActions["PAGE_LOAD"] = "pageLoad";
    EventActions["LINK_CLICK"] = "linkClick";
    EventActions["SYSTEM_EVENT"] = "systemEvent";
    EventActions["FORM_RESPONSE"] = "formResponse";
    EventActions["FORM_SUBMIT"] = "formSubmit";
    EventActions["IMPRESSION"] = "impression";
    EventActions["MARKETING"] = "marketing";
})(EventActions = exports.EventActions || (exports.EventActions = {}));
var LinkPosition;
(function (LinkPosition) {
    LinkPosition["GLOBAL_NAV"] = "GlobalNav";
    LinkPosition["SUB_NAV"] = "SubNav";
    LinkPosition["LEFT_NAV"] = "LeftNav";
    LinkPosition["RIHGT_NAV"] = "RightNav";
    LinkPosition["BODY"] = "Body";
    LinkPosition["MARQUEE"] = "Marquee";
    LinkPosition["CAROUSEL"] = "Carousel";
    LinkPosition["TAB"] = "Tab";
    LinkPosition["LINK_FARM"] = "LinkFarm";
    LinkPosition["FOOTER"] = "Footer";
    LinkPosition["BODY_MESSAGE"] = "Body_Message";
    LinkPosition["HEADER"] = "Header";
    LinkPosition["QUICK_LINKS"] = "QuickLinks";
    LinkPosition["LINK_FARM_1"] = "LinkFarm_1";
    LinkPosition["LINK_FARM_2"] = "LinkFarm_2";
    LinkPosition["LINK_FARM_3"] = "LinkFarm_3";
    LinkPosition["BODY_ALERTS"] = "BodyAlerts";
})(LinkPosition = exports.LinkPosition || (exports.LinkPosition = {}));
var SuccessFlags;
(function (SuccessFlags) {
    /** User’s action was successful */
    SuccessFlags[SuccessFlags["SUCCESSFUL"] = 1] = "SUCCESSFUL";
    /** User’s action unsuccessful
     * (system errors, e.g. back end system down or unrecognized user input/blank fields/etc.
     */
    SuccessFlags[SuccessFlags["UNSUCCESSFUL"] = 0] = "UNSUCCESSFUL";
    /** User cancelled the action */
    SuccessFlags[SuccessFlags["USER_CANCEL"] = -1] = "USER_CANCEL";
    /** Unknown */
    SuccessFlags[SuccessFlags["UNKNOWN"] = -2] = "UNKNOWN";
})(SuccessFlags = exports.SuccessFlags || (exports.SuccessFlags = {}));
var ErrorTypeOption;
(function (ErrorTypeOption) {
    ErrorTypeOption["Success_Admit"] = "Success_Admit";
    ErrorTypeOption["Planned_Downtime"] = "Planned_Downtime";
    ErrorTypeOption["Failure_BusinessRule"] = "Planned_Downtime";
    ErrorTypeOption["Failure_User"] = "Failure_User";
    ErrorTypeOption["Failure_System"] = "Failure_System";
    ErrorTypeOption["Failure_Data"] = "Failure_Data";
    ErrorTypeOption["UNKNOWN"] = "";
})(ErrorTypeOption = exports.ErrorTypeOption || (exports.ErrorTypeOption = {}));
var SubPanels;
(function (SubPanels) {
    SubPanels["ENJOY"] = "enjoy";
    SubPanels["FREESHIP"] = "freeShipping";
    SubPanels["SHIPPINGADD"] = "shippingAddress";
    SubPanels["SERVICEADD"] = "serviceAddress";
    SubPanels["BILLINGADD"] = "billingAddress";
    SubPanels["BUSINESSADD"] = "businessAddress";
})(SubPanels = exports.SubPanels || (exports.SubPanels = {}));
//# sourceMappingURL=ReportingService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/api/ReportingService.js
// module id = 141
// module chunks = 8